import autoAnimate from '@formkit/auto-animate'
import { FC, useEffect, useRef, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import ProjectUpdateImgModal from '../ProjectUpdateImgModal'

interface ProjectUpdateItemInterface {
  isLoading?: boolean
  projectUpdateDate: string
  projectUpdateImgLarge: string
  projectUpdateImgAltTagLarge: string
  projectUpdateImgThumbnail: string
  projectUpdateImgAltTagThumbnail: string
  projectUpdateContent: string
  projectUpdateTitle: string
}

export const ProjectUpdateItem: FC<ProjectUpdateItemInterface> = ({
  isLoading,
  projectUpdateDate,
  projectUpdateImgAltTagThumbnail,
  projectUpdateImgThumbnail,
  projectUpdateImgAltTagLarge,
  projectUpdateImgLarge,
  projectUpdateContent,
  projectUpdateTitle
}) => {
  const [show, setShow] = useState<boolean>(false)
  const wordLimit = 25
  const wordArray = (projectUpdateContent ?? '').split(' ')
  const summary = wordArray.slice(0, wordLimit).join(' ')
  const rest = wordArray.slice(wordLimit).join(' ')

  const parent = useRef<HTMLParagraphElement>(null)
  useEffect(() => {
    parent.current && autoAnimate(parent.current)
  }, [parent])

  return (
    <div className="wc-grid">
      <div className="wc-col-12 wc-col-md-8">
        <span className="wc-label-heading">
          {isLoading ? <Skeleton width={90} /> : projectUpdateDate}
        </span>
        <p className="h4">
          {isLoading ? <Skeleton width={220} /> : projectUpdateTitle}
        </p>
        <p ref={parent} style={{ overflow: 'hidden' }}>
          {!isLoading && <>{summary}</>}
          {!isLoading && show && <> {rest}</>}
          {isLoading && <Skeleton />}
        </p>
        {wordArray.length > wordLimit && (
          <button
            className="link"
            style={{ width: 81, margin: 0, padding: 0 }}
            onClick={() => {
              setShow((s) => !s)
            }}
          >
            Show {show ? 'less' : 'more'}
          </button>
        )}
      </div>
      <div className="wc-col-12 wc-col-md-4 order-first md:order-last">
        <ProjectUpdateImgModal
          projectUpdateImgThumbnail={projectUpdateImgThumbnail}
          projectUpdateImgAltTagThumbnail={projectUpdateImgAltTagThumbnail}
          projectUpdateImgLarge={projectUpdateImgLarge}
          projectUpdateImgAltTagLarge={projectUpdateImgAltTagLarge}
        />
      </div>
    </div>
  )
}

export default ProjectUpdateItem
